import { Link } from "react-router-dom";

import styled from "styled-components";

import Icon from "components/atoms/Icon";
import Image from "components/atoms/Image";
import Tooltip from "components/atoms/Tooltip";
import Button, { BUTTON_STYLES } from "components/atoms/button";

import PDFChatTitleInput from "components/organisms/review/PDFChatTitleInput";

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    min-width: 768px;
    height: 56px;
    background-color: var(--color-White);
    border-bottom: solid 1px var(--color-Line);
`;

const RightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const DivideLine = styled.div`
    height: 20px;
    border-right: solid 1px var(--color-Line);
`;

const TitleSection = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 16px;
    max-width: calc(100% - 480px);
`;

function PDFChatPageHeader(props) {
    return (
        <Container>
            <Link as={Link} to={props.reference ? "/reference" : "/"} reloadDocument>
                <Image name={"headerLogo"} />
            </Link>
            <TitleSection>
                <form>
                    <PDFChatTitleInput
                        bibliography={props.reference}
                        bibliographyMutation={props.bibliographyMutation}
                    />
                </form>
            </TitleSection>
            <RightSection>
                <DivideLine />
                {props.rightContent ? (
                    props.rightContent
                ) : (
                    <Tooltip message={"나가기"}>
                        <Button {...BUTTON_STYLES.actionPrimary} onlyIcon buttonSize={"32px"} onClick={window.close}>
                            <Icon name={"logout"} size={"12"} color={"var(--color-White)"} />
                        </Button>
                    </Tooltip>
                )}
            </RightSection>
        </Container>
    );
}

export default PDFChatPageHeader;
